import { format } from "date-fns";

export default function TreandingBlogPost({ data }) {
   const firstParagraph = data?.content?.blocks?.find((block) => block?.type === "Paragraph");
   var paragraphText = "";
   if (firstParagraph) {
      // Extract the HTML content of the first paragraph
      const paragraphHTML = firstParagraph.data.text;

      // Use a regular expression to remove HTML tags and then get the first 150 characters
      paragraphText = paragraphHTML.replace(/<[^>]*>/g, "").substring(0, 82);
   }
   return (
      <div className="blogPost__Card__SliderWrapper py-2">
         <a href={`/company/blogs/${data?._id}`}>
            <div className="treandingSection__blogPost">
               <img
                  src={`${process.env.REACT_APP_FILE_URL}/${data?.featured_image}`}
                  alt=""
                  className="blog_image"
               />
               <h5 className="blog_title mt-1">{data?.title}</h5>
               <p className="blog_date">{format(new Date(data?.created_at), "MMM d yyyy")}</p>
               <p className="blog_description">{paragraphText}...</p>
            </div>
         </a>
      </div>
   );
}
